import { Pipe, PipeTransform } from '@angular/core';
import { getHoursAndMinutes } from '@ui-kit/utility/getHoursAndMinutes';

@Pipe({ name: 'secondsToPeriod' })
export class SecondsToPeriodPipe implements PipeTransform {
  transform(value: any, period: 's' | 'h' = 's'): any {
    if (!value && value !== 0) {
      return ``;
    }

    let positive = null;

    if (value < 0) {
      positive = '-';
      value = Math.abs(value);
    }

    const hoursAndMinutes = getHoursAndMinutes(value, period);

    let hoursResult = `${hoursAndMinutes.h}`;
    let minutesResult = `${hoursAndMinutes.m}`;

    if (hoursAndMinutes.m === 0) {
      minutesResult = `${hoursAndMinutes.m}0`;
    }

    if (hoursAndMinutes.m < 10) {
      minutesResult = `0${hoursAndMinutes.m}`;
    }

    if (hoursAndMinutes.h < 10) {
      hoursResult = `0${hoursAndMinutes.h}`;
    }

    if (positive !== null) {
      return `-${hoursResult}:${minutesResult}`;
    }

    return `${hoursResult}:${minutesResult}`;
  }
}
